export function validatePasswordChange({ currentPassword, newPassword, confirmPassword }) {
    if (!currentPassword) return 'Ingresa tu contraseña actual.';
    if (newPassword.length < 8) return 'La nueva contraseña debe tener al menos 8 caracteres.';
    if (newPassword === currentPassword) return 'La nueva contraseña debe ser distinta a la actual.';
    if (newPassword !== confirmPassword) return 'Las contraseñas nuevas no coinciden.';
    return null;
}

export async function changePasswordWithReauthentication({
    user,
    currentPassword,
    newPassword,
    createCredential,
    reauthenticate,
    updatePassword,
}) {
    if (!user?.email) throw new Error('No se encontró el correo de esta cuenta.');
    const credential = createCredential(user.email, currentPassword);
    await reauthenticate(user, credential);
    await updatePassword(user, newPassword);
}

export function getPasswordChangeErrorMessage(error) {
    switch (error?.code) {
        case 'auth/invalid-credential':
        case 'auth/wrong-password':
            return 'La contraseña actual es incorrecta.';
        case 'auth/weak-password':
            return 'La nueva contraseña no cumple los requisitos de seguridad.';
        case 'auth/requires-recent-login':
            return 'Por seguridad, cierra sesión y vuelve a ingresar antes de cambiar la contraseña.';
        case 'auth/too-many-requests':
            return 'Hubo demasiados intentos. Espera unos minutos y vuelve a intentarlo.';
        case 'auth/network-request-failed':
            return 'No hay conexión. Revisa internet e inténtalo nuevamente.';
        default:
            return 'No se pudo cambiar la contraseña. Inténtalo nuevamente.';
    }
}
